import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
		clsx,
	} from "clsx"

	
export default /*@__PURE__*/_defineComponent({
  __name: 'VAlertBody',
  props: {
		className: {
			type: String,
			default: "",
		},
	},
  setup(__props) {

	const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(clsx)(__props.className, 'mt-4'))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})